import { Component, Input, OnChanges, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ButtonValue } from '../../dynamicform/models/common-models';
@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ButtonComponent implements OnChanges, AfterViewInit {
  @ViewChild('dynamicbutton', { read: true }) dynamicbutton: ElementRef;
  @Input() buttontype: ButtonValue;
  constructor(public _EL: ElementRef) {}
  @Output() valueChange = new EventEmitter();

  handleclick(e: ReturnButtonValue): void {
      this.valueChange.emit(e);
  }
  ngAfterViewInit() {
    return;
  }
  /**
   * @method function;
   * @function ngOnChanges;
   * @description change the input value
   */
  ngOnChanges() {
    return;
  }
}




export interface ReturnButtonValue {
 event: object;
 buttontype?: string;
 value?: number;
}

